import { render, staticRenderFns } from "./AAsignarCourseid.vue?vue&type=template&id=29587ee9"
import script from "./AAsignarCourseid.vue?vue&type=script&lang=js"
export * from "./AAsignarCourseid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports